// extracted by mini-css-extract-plugin
export default {"collapseIcon":"styles-module--collapseIcon--3PU50","open":"styles-module--open--3jTwi","header":"styles-module--header--CgASa","headerContent":"styles-module--headerContent--1SHPo"};